export default __webpack_public_path__ + "static/media/background-waveform.53346d2a.png";